import type { AccountInfo } from '@azure/msal-browser';

export function getCurrentUser(account: AccountInfo | null | undefined) {
    const claims = account?.idTokenClaims;
    const roles = claims?.extension_portalcrm_userType;
    return {
        account: account ?? null,
        identity: account ? `${account.homeAccountId}:${account.localAccountId}:${account.tenantId}` : null,
        personId: typeof claims?.extension_portalcrm_personid === 'string' ? claims.extension_portalcrm_personid : '',
        roles: typeof roles === 'string' ? roles.split(',').map(role => role.trim()).filter(Boolean) : [],
        hasRoleClaim: typeof roles === 'string',
        isTransferOnboarding: claims?.extension_portalcrm_isTransferOnboarding === true,
        isAffiliateOnboarding: claims?.extension_portalcrm_isAffiliateOnboarding === true,
        isMembershipOnboarding: claims?.extension_portalcrm_isMemberOnboarding === true
            || claims?.extension_portalcrm_isFellowOnboarding === true
    };
}

export type CurrentUser = ReturnType<typeof getCurrentUser>;
